import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {WidgetBodyRendererDirective} from './widget-body-renderer.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        WidgetBodyRendererDirective
    ],
    exports: [
        WidgetBodyRendererDirective
    ]
})
export class WidgetBodyRendererModule {}
